import request from '../../shared/request'
import config from '../../config'
import store from '../store'

const getAuthorization = () => {
  const state = store.getState()
  const token = state.auth && state.auth.token
  return token ? `Bearer ${token}` : void 0
}

export function fetchCorreios(page = 1, itemsPerPage = 15, filters = {}) {
  const queryParams = {
    page,
    per_page: itemsPerPage,
    ...filters
  }
  
  return request('v1/services/tracking/shipments', {
    method: 'GET',
    qsParams: queryParams
  })
}

export function downloadSpreadsheet(filters = {}) {
  const queryParams = new URLSearchParams()
  
  // Adicionar filtros à query string
  Object.keys(filters).forEach(key => {
    if (filters[key] !== undefined && filters[key] !== '') {
      queryParams.append(key, filters[key])
    }
  })

  const url = `${config.apiUrl}/v1/services/tracking/shipments/export?${queryParams.toString()}`
  
  return fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': getAuthorization(),
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.blob()
  })
}

export function importCSV(file, templateBotMaker) {
  const formData = new FormData()
  formData.append('csv_file', file)
  
  if (templateBotMaker) {
    formData.append('template_botmaker', templateBotMaker)
  }
  
  // Para FormData, precisamos usar fetch direto para evitar problemas com Content-Type
  return fetch(`${config.apiUrl}/v1/services/tracking/shipments/import`, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': getAuthorization()
    }
  }).then(response => {
    if (!response.ok) {
      throw new Error('Erro na importação')
    }
    return response.json()
  }).then(data => {
    return data
  }).catch(error => {
    throw error
  })
}

export function deleteShipments(ids) {
  return fetch(`${config.apiUrl}/v1/services/tracking/shipments/delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': getAuthorization()
    },
    body: JSON.stringify({
      ids: ids.map(id => String(id))
    })
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  }).catch(error => {
    throw error
  })
}

export function sendMessage(ids) {
  return fetch(`${config.apiUrl}/v1/services/tracking/shipments/send-message`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': getAuthorization()
    },
    body: JSON.stringify({
      ids: ids.map(id => String(id))
    })
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  }).catch(error => {
    throw error
  })
}

export function cancelMessage(ids) {
  return fetch(`${config.apiUrl}/v1/services/tracking/shipments/cancel-message`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': getAuthorization()
    },
    body: JSON.stringify({
      ids: ids.map(id => String(id))
    })
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  }).catch(error => {
    throw error
  })
} 